module.exports = __webpack_public_path__ + "static/media/instagram_w.329907b0.png";